import { render, staticRenderFns } from "./RetailerPrice.vue?vue&type=template&id=1bc32789&"
import script from "./RetailerPrice.vue?vue&type=script&lang=js&"
export * from "./RetailerPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports